import ResponsiveContainer from "../../../../layouts/ResponsiveContainer"
import { LETTERS } from "../../../../utils/const"

interface FilterProps {
    activeLetters: Set<string>;
    selectedLetter: string | null;
    onSelect: (letter: string) => void;
}

const Filter = ({ activeLetters, selectedLetter, onSelect }: FilterProps) => {

    const handleSelect = (letter: string) => {
        if (!activeLetters.has(letter)) return;
        onSelect(letter);
    }

    return (
        <ResponsiveContainer className="relative z-[24426]">
            <div className='bg-primary-100 rounded-md shadow-custom-dual w-full'>
                <div className="p-4 flex flex-wrap gap-1">
                    {LETTERS.map((letter) => {
                        const isActive = activeLetters.has(letter);
                        const isSelected = selectedLetter === letter;

                        return (
                            <button
                                key={letter}
                                onClick={() => handleSelect(letter)}
                                disabled={!isActive}
                                className={`py-2 px-4 text-llarge rounded-sm  
                                    ${isSelected
                                        ? "text-primary-500 bg-primary-40 text-gray-100"
                                        : isActive
                                            ? "text-system-light-40 hover:bg-system-light-10"
                                            : "text-system-light-20 cursor-not-allowed opacity-40"
                                    }`}
                            >
                                {letter}
                            </button>
                        )
                    })}
                </div>
            </div>
        </ResponsiveContainer>
    )
}

export default Filter